<template>
  <BaseAction>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <SecondaryButton
          v-if="showMoveTo"
          :loading="isLoading"
          textColor="#0965dc"
          v-on="on"
        >
          <v-icon>
            mdi-clipboard-arrow-right-outline
          </v-icon>
          Move to...
        </SecondaryButton>
      </template>
      <v-list class="statuses-list">
        <v-list-item-group color="primary">
          <v-list-item v-for="status in statusesToShow" :key="status.id">
            <v-list-item-content>
              <v-list-item-title @click="updateStatus(status.name)">
                <v-icon>
                  mdi-clipboard-text-outline
                </v-icon>
                {{ status.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";
import { filter, size, remove, map, cloneDeep } from "lodash";
import { UPDATE_APPLICATION } from "@/store/modules/applications/actions";
import { APPLICATION_NAMESPACE } from "@/store/modules/applications";
import { createNamespacedHelpers } from "vuex";

const { mapActions } = createNamespacedHelpers(APPLICATION_NAMESPACE);

export default {
  components: {
    BaseAction,
    SecondaryButton
  },
  data() {
    return {
      isLoading: false
    };
  },
  props: {
    applications: {
      type: Array,
      required: true
    },
    evaluationStatuses: Array
  },
  computed: {
    currentEvaluationStatuses() {
      return map(this.applications, application => {
        return application.evaluationStatus;
      });
    },
    statusesToShow() {
      const statusesToShow = cloneDeep(this.evaluationStatuses);
      map(this.currentEvaluationStatuses, currentEvaluationStatus => {
        remove(
          statusesToShow,
          status =>
            (status.previousStatus &&
              status.previousStatus !== currentEvaluationStatus) ||
            status.name === currentEvaluationStatus
        );
      });
      return statusesToShow;
    },
    otherStatuses() {
      return filter(
        this.evaluationStatuses,
        status => status.previousStatus !== this.currentEvaluationStatus
      );
    },
    showMoveTo() {
      return size(this.evaluationStatuses);
    }
  },
  methods: {
    ...mapActions({
      updateApplication: UPDATE_APPLICATION
    }),
    async updateStatus(evaluationStatus) {
      this.isLoading = true;
      await Promise.all(
        map(this.applications, async application => {
          await this.updateApplication({
            id: application.id,
            evaluationStatus
          });
        })
      );
      this.$emit("statusChanged");
      this.isLoading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.statuses-list {
  overflow-y: scroll;
  max-height: calc(100vh - 30px);
}
</style>
